import dealerInfo from './dealerInfo';
import contactInfo from './contactInfo';
import mapLink from './mapLink';

const root = {
	dealerInfo,
	contactInfo,
	mapLink
};

export default root;
